// extracted by css-extract-rspack-plugin
export default {"titleText":"titles-module__titleText___nP05g","subTitleText":"titles-module__subTitleText___rk8SL"};